import Vue from "vue";

/**
 * Change casualty status only from VR to CP
 * @author Jose Luis R
 * @param id Casualty's id
 * @return {Object}
 */

export default ({ id }) => {
  return Vue.$http.get(`sinisters/affected/pass-rs-to-cp/${id}/`);
};



// WEBPACK FOOTER //
// ./src/services/sinister/changeStatusToCP.js